import {
  imDeleteFromArrayById,
  imPush,
  imSetToArray,
  imSetToObj,
} from '@client/shared/utils/immutableUtils/immutableUtils';

export const CAMPAIGN_REDUCER_KEY = 'campaignReducer';

export const LOAD_CAMPAIGN_BRIEF = 'LOAD_CAMPAIGN_BRIEF';
export const LOAD_CAMPAIGN_MEDIA_SUMMARY = 'LOAD_CAMPAIGN_MEDIA_SUMMARY';
export const LOAD_CAMPAIGN_REQUEST = 'LOAD_CAMPAIGN_REQUEST';
export const LOAD_CAMPAIGN = 'LOAD_CAMPAIGN';
export const LOAD_CAMPAIGN_FAILURE = 'LOAD_CAMPAIGN_FAILURE';
export const LOAD_CAMPAIGN_IS_COMPLETABLE = 'LOAD_CAMPAIGN_IS_COMPLETABLE';
export const POST_AND_HANDLE_CAMPAIGN = 'POST_AND_HANDLE_CAMPAIGN';
export const PUT_AND_HANDLE_CAMPAIGN_STATUS = 'PUT_AND_HANDLE_CAMPAIGN_STATUS';
export const POST_AND_HANDLE_CAMPAIGN_IMAGE = 'POST_AND_HANDLE_CAMPAIGN_IMAGE';
export const PUT_AND_HANDLE_CAMPAIGN_DIRECTIVE_IMAGE =
  'PUT_AND_HANDLE_CAMPAIGN_DIRECTIVE_IMAGE';
export const PUT_AND_HANDLE_CAMPAIGN = 'PUT_AND_HANDLE_CAMPAIGN';
export const DELETE_AND_HANDLE_CAMPAIGN = 'DELETE_AND_HANDLE_CAMPAIGN';
export const SET_CAMPAIGN_ERROR = 'SET_CAMPAIGN_ERROR';
export const PUT_AND_HANDLE_CAMPAIGN_ATTACHMENT =
  'PUT_AND_HANDLE_CAMPAIGN_ATTACHMENT';
export const PUT_AND_HANDLE_SUMMARY_PDF_AVAILABILITY =
  'PUT_AND_HANDLE_SUMMARY_PDF_AVAILABILITY';
export const POST_AND_HANDLE_CAMPAIGN_INFLUENCER_NOTIFICATION =
  'POST_AND_HANDLE_CAMPAIGN_INFLUENCER_NOTIFICATION';
export const POST_AND_HANDLE_CAMPAIGN_ALL_INFLUENCERS_NOTIFICATION =
  'POST_AND_HANDLE_CAMPAIGN_ALL_INFLUENCERS_NOTIFICATION';
export const SET_VIEW_ONLY_MY_CAMPAIGN = 'SET_VIEW_ONLY_MY_CAMPAIGN';

export const CAMPAIGN_LOAD_STATUS = {
  LOADING: 'loading',
  LOADED: 'loaded',
  ERROR: 'error',
};

/* DEFAULT CAMPAIGN STATE */
let defaultState = {
  campaigns: [],
  campaignLoadStatus: {},
  campaignBriefs: [],
  campaignMediaSummaries: [],
  isViewOnlyMyCampaign: false,
};

/* REDUCER */
export default function(state = defaultState, action = {}) {
  switch (action.type) {
    case LOAD_CAMPAIGN_REQUEST: {
      return {
        ...state,
        campaignLoadStatus: {
          ...state.campaignLoadStatus,
          [action.payload.campaignId]: CAMPAIGN_LOAD_STATUS.LOADING,
        },
      };
    }
    case LOAD_CAMPAIGN: {
      const { campaign } = action.payload;
      return {
        ...state,
        campaigns: imSetToArray(state.campaigns, campaign, 'id'),
        campaignLoadStatus: {
          ...state.campaignLoadStatus,
          [campaign.id]: CAMPAIGN_LOAD_STATUS.LOADED,
        },
      };
    }
    case LOAD_CAMPAIGN_FAILURE: {
      return {
        ...state,
        campaignLoadStatus: {
          ...state.campaignLoadStatus,
          [action.payload.campaignId]: CAMPAIGN_LOAD_STATUS.ERROR,
        },
      };
    }
    case LOAD_CAMPAIGN_BRIEF: {
      return {
        ...state,
        campaignBriefs: imSetToArray(
          state.campaignBriefs,
          {
            ...action.payload.campaignBrief,
            campaignId: action.payload.campaignId,
          },
          'campaignId'
        ),
      };
    }
    case LOAD_CAMPAIGN_MEDIA_SUMMARY: {
      return {
        ...state,
        campaignMediaSummaries: imSetToArray(
          state.campaignMediaSummaries,
          {
            ...action.payload.campaignMediaSummary,
            campaignId: action.payload.campaignId,
          },
          'campaignId'
        ),
      };
    }
    case LOAD_CAMPAIGN_IS_COMPLETABLE: {
      const { completable, campaignId } = action.payload;
      const { campaigns } = state;

      const campaign = campaigns.find((campaign) => campaign.id === campaignId);
      const updatedCampaign = imSetToObj(campaign, 'completable', completable);

      return {
        ...state,
        campaigns: imSetToArray(campaigns, updatedCampaign, 'id'),
      };
    }
    case POST_AND_HANDLE_CAMPAIGN: {
      return {
        ...state,
        campaigns: imPush(state.campaigns, action.payload),
      };
    }
    case POST_AND_HANDLE_CAMPAIGN_IMAGE: {
      const { imageUrl, campaignId } = action.payload;
      const { campaigns } = state;

      const campaign = campaigns.find((campaign) => campaign.id === campaignId);
      const updatedCampaign = imSetToObj(campaign, 'imageUrl', imageUrl);

      return {
        ...state,
        campaigns: imSetToArray(campaigns, updatedCampaign, 'id'),
      };
    }
    case PUT_AND_HANDLE_SUMMARY_PDF_AVAILABILITY: {
      const { campaign } = action.payload;
      const { campaigns } = state;

      return {
        ...state,
        campaigns: imSetToArray(campaigns, campaign, 'id'),
      };
    }

    case PUT_AND_HANDLE_CAMPAIGN_DIRECTIVE_IMAGE: {
      const { imageUrl, campaignId } = action.payload;
      const { campaigns } = state;

      const campaign = campaigns.find((campaign) => campaign.id === campaignId);
      const updatedCampaign = imSetToObj(
        campaign,
        'directiveImageUrlList',
        imageUrl
      );

      return {
        ...state,
        campaigns: imSetToArray(campaigns, updatedCampaign, 'id'),
      };
    }
    case PUT_AND_HANDLE_CAMPAIGN: {
      return {
        ...state,
        campaigns: imSetToArray(state.campaigns, action.payload, 'id'),
      };
    }
    case PUT_AND_HANDLE_CAMPAIGN_STATUS: {
      return state;
    }
    case DELETE_AND_HANDLE_CAMPAIGN: {
      return {
        ...state,
        campaigns: imDeleteFromArrayById(state.campaigns, 'id', action.payload),
      };
    }
    case SET_CAMPAIGN_ERROR: {
      return state;
    }
    case POST_AND_HANDLE_CAMPAIGN_INFLUENCER_NOTIFICATION: {
      //TODO
      return state;
    }
    case POST_AND_HANDLE_CAMPAIGN_ALL_INFLUENCERS_NOTIFICATION: {
      //TODO
      return state;
    }
    case SET_VIEW_ONLY_MY_CAMPAIGN: {
      return {
        ...state,
        isViewOnlyMyCampaign: !state.isViewOnlyMyCampaign,
      };
    }
    default:
      return state;
  }
}
